import '../../../../styles/ModalFacturaEmitida.css'
import Printer from '../../../../media/felsv/Printer.svg'
import Email from '../../../../media/felsv/Email.svg'
import Download from '../../../../media/felsv/Download.svg'
import Folder from '../../../../media/felsv/Folder.svg'
import DownloadImage from '../../../../media/felsv/DownloadImage.svg'
import DeleteFileIcon from '../../../../media/felsv/dark_delete_file_icon.svg'

import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision, actionsOperaciones} from '../../../../actions/action-creators'
import {facturacionClearAll} from '../../../../actions/facturacion/facturacionEmision.actions'
import {useHistory} from 'react-router-dom'
import { State } from '../../../../reducers'
import { ModalBase } from '../../../../components/Modals/ModalBase'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { generateQRImageFromBits } from '../../../../actions/operaciones/operaciones.actions'
import { handleRestartStateFormaPago } from '../../../../actions/forma-pago.actions'

const ModalsResumenDocEmitidoV1 = () => {
  const history = useHistory()
  const {datosFacturaRes, opcionesActiva} = useSelector((state: State) => state.facturacion)
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionFacturacionEmision, dispatch)
  const actionsOP = bindActionCreators(actionsOperaciones, dispatch)

  const nuevaFactura = () => {
    dispatch(facturacionClearAll())
    dispatch(handleRestartStateFormaPago())

    if (activeDoc.idDoc === "05") {
      history.push('/history-invoice')
    } else {
      history.push('/otros-documentos/emitir/formulario')
    }
  }

  const handlePDF = () => {
    actionsOP.getFacturaPDF_New(
      {Documento: datosFacturaRes?.JsonFactura, Sello: datosFacturaRes?.Sello},
      datosFacturaRes?.serie
    )
  }

  const handleExcel = () => {
    actionsOP.getExcelFactura(
      {Documento: datosFacturaRes?.JsonFactura, Sello: datosFacturaRes?.Sello},
      datosFacturaRes?.codigoGeneracion
    )
  }
  const handleImage = () => {
    actionsOP.getFacturaImage(
      {Documento: datosFacturaRes?.JsonFactura, Sello: datosFacturaRes?.Sello},
      datosFacturaRes?.codigoGeneracion
    )
  }

  const handleCerrar = () => {
    if (!opcionesActiva) {
      actionsFE.facturacionCloseModalDocumentoEmitida();
      history.push('/otros-documentos');
    } else {
      actionsFE.facturacionCloseModalFacturaEmitida();
    }
  }

  const handleDetalle = () => {
    actionsFE.facturacionVerDetalleDocumentoEmitido();
    history.push('/otros-documentos/emitir/detalle');
  }

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '600px', backgroundColor: '#f1f1f1'}}>
      <div className='modal-card' style={{width: '100%'}}>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{opcionesActiva ? 'Más Opciones' : '¡Documento Emitido!'}</h3>
          </div>
          <div className='form-separator'></div>
          <div className='modal-emitido-div-qr'>
            {datosFacturaRes?.qr && (
              <img src={generateQRImageFromBits(datosFacturaRes?.qr.replace("data:image/jpeg;base64,", ""))} alt='Código-qr' className='modal-emitido-img-qr' />
            )}
          </div>
          <div
            className='m button-actions'
            style={{margin: '0 auto', width: '100%', textAlign: 'center'}}
          >
            <div style={{display: 'flex', gap: '16px', justifyContent: 'center'}}>
              <Tooltip content='Imprimir'>
                <button
                  className='modal-emitido-button-icon'
                  onClick={() => actionsFE.facturacionOpenCloseModalImprimir(true)}
                >
                  <img src={Printer} alt='Imprimir' />
                </button>
              </Tooltip>
              <Tooltip content='Enviar por Correo'>
                <button
                  className='modal-emitido-button-icon'
                  onClick={() => actionsFE.facturacionOpenCloseModalEmail(true)}
                >
                  <img src={Email} alt='correo electrónico' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar como PDF'>
                <button className='modal-emitido-button-icon' onClick={handlePDF}>
                  <img src={Download} alt='Download' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar como Excel'>
                <button className='modal-emitido-button-icon' onClick={handleExcel}>
                  <img src={Folder} alt='Download folder' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar como Imagen'>
                <button className='modal-emitido-button-icon' onClick={handleImage}>
                  <img src={DownloadImage} alt='Download 2' />
                </button>
              </Tooltip>
              <Tooltip content='Anular documento'>
                <button className='modal-emitido-button-icon' onClick={() => actionsFE.facturacionOpenCloseModalAnularV2(true)}>
                  <img src={DeleteFileIcon} alt='Anular' />
                </button>
              </Tooltip>
            </div>
          </div>
          {!opcionesActiva && (
            <div className='w-layout-hflex button-actions'>
              <button
                className='m button transparent w-inline-block'
                onClick={handleDetalle}
              >
                Ver detalle completo
              </button>
            </div>
          )}
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button
              className='m button transparent w-inline-block'
              onClick={handleCerrar}
            >
              <div>Cerrar</div>
            </button>
            {!opcionesActiva && (
              <button className='m button w-inline-block' onClick={nuevaFactura}>
                <div>Nuevo documento</div>
              </button>
            )}
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalsResumenDocEmitidoV1
